<template>
  <div class="page-goods-list">
    <plugin-sort-line
      :sortList="sortList"
      @sortChange="sortChange"
      @sortReset="sortReset"
    ></plugin-sort-line>
    <!-- 筛选 -->
    <YYFilter
      :menuTop="0"
      :filterData="fabricList"
      :updateMenuName="true"
      :isShowPage="filterShow"
      @confirm="confirm"
    />
    <!-- 占位 -->
    <div class="place"></div>
    <plugin-base-list
      v-if="showList"
      id="list"
      ref="list"
      height="calc(100% - 106px)"
      :list.sync="list"
      :pageConfig.sync="pageConfig"
      :fetchFun="fetchFun"
    >
      <template v-if="pageConfig.goodsTemplateId == 3">
        <div
          v-for="item in list"
          :key="item.id"
          class="goods-box"
          @click="view(item.id)"
        >
          <van-row type="flex" align="top" :gutter="10">
            <van-col span="7" class="img-area">
              <!-- <van-image v-if='item.image' :src="fileURL + item.image[0].fileSmallPath" alt="" width='100%'>
                <template v-slot:error>
                  <van-image :src="fileURL + templateInfo[0].templateBitmap.fileSmallPath">
                    <template v-slot:error>加载失败</template>
                  </van-image>
                </template>
              </van-image> -->
              <plugin-image
                v-if="item.image"
                :src="item.image[0].fileSmallPath"
                :templateId="pageConfig.goodsTemplateId"
              ></plugin-image>
              <plugin-image
                v-else
                src="https://www.dayaotex.com/file/small/9/14/1568435302810.png"
                :templateId="pageConfig.goodsTemplateId"
              ></plugin-image>
            </van-col>
            <van-col span="17" class="top-offset">
              <p>
                <!-- <span class='fz12 c95 ml10'>{{item.kcddz}}</span> -->
                <span
                  v-for="(detail, index) in filterisAppMain(item.details, '1')"
                  :key="index"
                  class="mainDetail"
                  >{{ detail.detailsValue }}</span
                >
                <span class="mainDetail">{{ item.ys }}</span>
              </p>
              <!-- <p>
                <span v-for='(detail, index) in filterisAppMain(item.details, "1")' :key="index" class='mainDetail'>{{detail.detailsValue}}</span>
              </p> -->
              <p>
                <span class="subordinate-detial fz14 c95" v-if="item.weight"
                  >{{ item.weight }}g/m&sup2;</span
                >
                <span
                  v-for="(detail, index) in filterisAppMain(item.details, '0')"
                  :key="index"
                  class="subordinate-detial fz14 c95"
                  >{{ detail.detailsValue }}</span
                >
              </p>
              <p>
                <span
                  v-if="item.samplegoodsprice && item.samplegoodsprice.length"
                  class="mr10 fz14 c95"
                >
                  {{ item.samplegoodsprice[0].typeName }}：{{
                    item.samplegoodsprice[0].inventory
                  }}{{ item.samplegoodsprice[0].goodsSpecificationsUnit }}
                </span>
                <span class="mr10 fz14 c95">
                  <!--span v-if='item.goodsBigTruclist && item.goodsBigTruclist.length'>{{item.goodsBigTruclist[0].typeName}}：</span>
                  <template v-if='item.goodsBigTruclist && item.goodsBigTruclist.length && item.goodsBigTruclist[0].goodsSpecificationsInterval'>
                    {{getStock(item.goodsBigTruclist[0].goodsSpecificationsInterval)}}{{item.goodsBigTruclist[0].goodsSpecificationsUnit}}
                  </template>
                  <template v-else-if='Number(item.inventory)'>
                    {{getStock(item.inventory)}}{{item.unit}}
                  </template>
                  <template v-else>
                    可咨询
                  </template-->
                  现货：
                  <template
                    v-if="
                      item.activityList &&
                      item.activityList.activityStatus == 1 &&
                      item.activityList.inventoryOn == 1 &&
                      item.activityList.activityInventory
                    "
                  >
                    {{ item.activityList.activityInventory }}KG
                  </template>
                  <template
                    v-else-if="
                      item.goodsBigTruclist &&
                      item.goodsBigTruclist.length &&
                      item.goodsBigTruclist[0].goodsSpecificationsInterval
                    "
                  >
                    {{
                      getStock(
                        item.goodsBigTruclist[0].goodsSpecificationsInterval
                      )
                    }}{{ item.goodsBigTruclist[0].goodsSpecificationsUnit }}
                  </template>
                  <template v-else-if="Number(item.inventory)">
                    {{ getStock(item.inventory) }}{{ item.unit }}
                  </template>
                  <template v-else> 可咨询 </template>
                </span>
              </p>
              <p class="fz14 c95">
                <van-tag type="danger" class="mr5" v-if="item.saleType == 0"
                  >自营</van-tag
                >
                <van-tag
                  :color="item.activityList.activityTagsColor"
                  class="mr10"
                  v-if="
                    item.activityList &&
                    item.activityList.activityTagsTagsStatus != '0'
                  "
                  >{{ item.activityList.activityTagsName }}</van-tag
                >
                <template v-if="item.recommendList">
                  <van-tag
                    v-for="(tag, index) in item.recommendList"
                    :key="index"
                    :color="tag.recommendTagsColor"
                  >
                    <template v-if="tag.recommendTagsStatus != '1'">
                      {{ tag.recommendTagsName }}
                    </template>
                  </van-tag>
                </template>
                商品编码: {{ item.goodsCode }}
              </p>
              <!--p v-if='item.quailtyLevel'>
                <span>质量等级: </span><span class="fw500 fz14 c3">{{item.quailtyLevel}}</span>
              </p-->
            </van-col>
          </van-row>
        </div>
      </template>
      <template v-else>
        <div
          v-for="item in list"
          :key="item.id"
          class="goods-box"
          @click="view(item.id)"
        >
          <van-row type="flex" align="center">
            <van-col span="18">
              <p>
                <span
                  v-for="(detail, index) in filterisAppMain(item.details, '1')"
                  :key="index"
                  class="mainDetail"
                  >{{ detail.detailsValue }}</span
                >
              </p>
              <p>
                <van-tag type="danger" v-if="item.saleType == 0">自营</van-tag>
                <van-tag type="primary" v-if="item.saleType == 1">三方</van-tag>
                <van-tag
                  :color="item.activityList.activityTagsColor"
                  class="mr10"
                  v-if="
                    item.activityList &&
                    item.activityList.activityTagsTagsStatus != '0'
                  "
                  >{{ item.activityList.activityTagsName }}</van-tag
                >
                <template v-if="item.recommendList">
                  <van-tag
                    v-for="(tag, index) in item.recommendList"
                    :key="index"
                    :color="tag.recommendTagsColor"
                  >
                    <template
                      v-if="
                        tag.recommendStatus == '1' &&
                        tag.recommendTagsStatus == '1'
                      "
                    >
                      {{ tag.recommendTagsName }}
                    </template>
                  </van-tag>
                </template>
                <!-- <span class='fz12 c95 ml10'>{{item.kcddz}}</span> -->
              </p>
              <p v-if="pageConfig.goodsTemplateId == 1">
                <span class="subordinate-detial fz14 c95">{{
                  filterDetailsName(item.details, "原料")
                }}</span>
                <span class="subordinate-detial fz14 c95">{{
                  filterDetailsName(item.details, "配比")
                }}</span>
                <span class="subordinate-detial fz14 c95">{{
                  filterDetailsName(item.details, "用途")
                }}</span>
                <span
                  class="
                    subordinate-detial
                    fz14
                    c95
                    red-c
                    subordinate-detial-prx
                  "
                  >{{ filterDetailsName(item.details, "漂染性") }}</span
                >
              </p>
              <p v-if="pageConfig.goodsTemplateId == 2">
                <!-- <span v-for='(detail, index) in filterisAppMain(item.details, "0")' :key="index" class='subordinate-detial fz14 c95'>{{detail.detailsValue}}</span> -->
                <span class="subordinate-detial fz14 c95">{{
                  filterDetailsName(item.details, "原料")
                }}</span>
                <span class="subordinate-detial fz14 c95">{{
                  filterDetailsName(item.details, "组织")
                }}</span>
                <span class="subordinate-detial fz14 c95">{{
                  filterDetailsName(item.details, "品名")
                }}</span>
                <span
                  class="
                    subordinate-detial
                    fz14
                    c95
                    red-c
                    subordinate-detial-prx
                  "
                  >{{ filterDetailsName(item.details, "漂染性") }}</span
                >
                <span class="subordinate-detial fz14 c95">{{
                  filterDetailsName(item.details, "纺纱工艺")
                }}</span>
              </p>
              <p class="fz14 c95">商品编码: {{ item.goodsCode }}</p>
              <p class="fz14 c95">
                <!-- 现货数量: -->
                <!--span v-if='item.goodsBigTruclist && item.goodsBigTruclist.length'>{{item.goodsBigTruclist[0].typeName}}：</span-->
                数量:
                <template
                  v-if="
                    item.activityList &&
                    item.activityList.activityStatus == 1 &&
                    item.activityList.inventoryOn == 1 &&
                    item.activityList.activityInventory
                  "
                >
                  {{ item.activityList.activityInventory }}{{ item.unit }}
                </template>
                <template
                  v-else-if="
                    item.goodsBigTruclist &&
                    item.goodsBigTruclist.length &&
                    item.goodsBigTruclist[0].goodsSpecificationsInterval
                  "
                >
                  {{
                    getStock(
                      item.goodsBigTruclist[0].goodsSpecificationsInterval
                    )
                  }}{{ item.goodsBigTruclist[0].goodsSpecificationsUnit }}
                </template>
                <template v-else-if="Number(item.inventory)">
                  {{ getStock(item.inventory) }}{{ item.unit }}
                </template>
                <template v-else> 可咨询 </template>
                <!--template v-if='item.goodsBigTruclist && item.goodsBigTruclist.length && item.goodsBigTruclist[0].goodsSpecificationsInterval'>
                  {{getStock(item.goodsBigTruclist[0].goodsSpecificationsInterval)}}{{item.goodsBigTruclist[0].goodsSpecificationsUnit}}
                </template>
                <template v-else-if='Number(item.inventory)'>
                  {{getStock(item.inventory)}}{{item.unit}}
                </template>
                <template v-else>
                  可咨询
                </template-->
              </p>
              <!--p v-if='item.quailtyLevel'>
                <span>质量等级: </span><span class="fw500 fz14 c3">{{item.quailtyLevel}}</span>
              </p-->
            </van-col>
            <van-col span="6" class="tr-s right-part">
              <p class="fz20 red-c fw500">
                <template
                  v-if="
                    item.activityList &&
                    (item.activityList.activityStatus == 1 ||
                      item.activityList.activityStatus == 0) &&
                    Number(item.activityList.activityPrice)
                  "
                >
                  <div>{{ item.activityList.activityPrice }}</div>
                  <div class="fz14 c95">
                    <s>{{ item.singleMachine }}</s>
                  </div>
                </template>
                <template
                  class="fz20 red-c fw500"
                  v-else-if="Number(item.singleMachine)"
                >
                  {{ item.singleMachine }}
                </template>
                <template v-else> 可咨询 </template>
              </p>
              <p class="fz12 c95">元/{{ item.unit }}</p>
              <p class="fz12 c95">
                {{ formatDate(new Date(item.updatepricedate), "yyyy-MM-dd") }}
              </p>
              <!-- <p class='fz12 c95'>{{item.updateTime}}</p> -->
            </van-col>
          </van-row>
        </div>
      </template>
      <!-- <div class="van-list__finished-text finished-text" id="finished-text" v-if='list.length == 0'>
		  <div>抱歉！没有找到符合条件的产品</div>
		  <div @click="toKeFu">可以咨询&nbsp;<span style="color:#419FFF">在线客服</span></div>
		  <div>或点击拨打客服热线&nbsp;&nbsp;<a href="tel:400-8623332">400-862-3332</a></div>
	  </div>	   -->
    </plugin-base-list>

    <!-- <van-popup
      v-model="showfilter"
      :overlay='true'
      position="right"
      get-container="body"
      :style="{ width: '80%', height: '100%', top: '55%' }">
      <plugin-screen-filter
        v-if='showfilter'
        :templateId='pageConfig.goodsTemplateId'
        :selectList.sync='selectList'
        :selectedFilter='selectedFilter'
        @submit="submitFilter">
      </plugin-screen-filter>
    </van-popup> -->
  </div>
</template>
<script>
/**
 * 商品列表
 * @author shendeying
 */
import BackEventMixins from "~/mixins/back-event-mixins";
import config from "$config";
import api from "api/goods";
import CommonUtils from "utils/CommonUtils";
import { mapMutations, mapGetters } from "vuex";
import { GET_SCREEN } from "$getters";
import { SET_NAV_CALLBACK } from "$mutations";
export default {
  name: "page-goods-list",
  mixins: [BackEventMixins],
  data() {
    return {
      templateInfo: null,
      showList: false,
      selectList: [],
      selectedFilter: [],
      pageConfig: {
        page: 0,
        size: 10,
        goodsTemplateId: "",
        goodsSearchTemplateIdList: [],
        sort: [],
        keyword: null,
        explosion: null,
        recommend: null,
      },
      list: [],
      fetchFun: api.selectAppGoodsList,
      sortList: [
        {
          name: "inventory", // 库存:name=inventory,价格 name=singlemachine
          label: "数量排序", // sortCol: 0 // 1降序0升序
        },
        {
          name: "singlemachine",
          label: "价格排序", // sortCol: 0 // 1降序0升序
        },
      ],
      showfilter: false,
      isFromCategory: false, // 是否从分类页跳转至此
      filterShow: false,
      fabricList: [],
      // fabricList: [
      // 	[{
      // 			"templateIdName": "面料类型",
      // 			"level": 2,
      // 			"templateId": 113,
      // 			"parentId": 3,
      // 			"child": [{
      // 					"templateIdName": "半漂布",
      // 					"level": 3,
      // 					"templateId": 114,
      // 					"parentId": 113
      // 				},
      // 				{
      // 					"templateIdName": "染色布",
      // 					"level": 3,
      // 					"templateId": 115,
      // 					"parentId": 113
      // 				},
      // 				{
      // 					"templateIdName": "印花布",
      // 					"level": 3,
      // 					"templateId": 116,
      // 					"parentId": 113
      // 				},
      // 				{
      // 					"templateIdName": "色织布",
      // 					"level": 3,
      // 					"templateId": 117,
      // 					"parentId": 113
      // 				},
      // 				{
      // 					"templateIdName": "针织布",
      // 					"level": 3,
      // 					"templateId": 315,
      // 					"parentId": 113
      // 				}
      // 			]
      // 		},
      // 		{
      // 			"templateIdName": "原料",
      // 			"level": 2,
      // 			"templateId": 118,
      // 			"parentId": 3,
      // 			"child": [{
      // 					"templateIdName": "全棉",
      // 					"level": 3,
      // 					"templateId": 119,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "亚麻",
      // 					"level": 3,
      // 					"templateId": 120,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "涤棉",
      // 					"level": 3,
      // 					"templateId": 123,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "锦棉",
      // 					"level": 3,
      // 					"templateId": 124,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "腈棉",
      // 					"level": 3,
      // 					"templateId": 125,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "粘胶(人棉)",
      // 					"level": 3,
      // 					"templateId": 126,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "天丝",
      // 					"level": 3,
      // 					"templateId": 127,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "莫代尔",
      // 					"level": 3,
      // 					"templateId": 128,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "CVC",
      // 					"level": 3,
      // 					"templateId": 129,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "竹炭纤维",
      // 					"level": 3,
      // 					"templateId": 164,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "羊毛",
      // 					"level": 3,
      // 					"templateId": 326,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "粘棉",
      // 					"level": 3,
      // 					"templateId": 335,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "麻棉",
      // 					"level": 3,
      // 					"templateId": 336,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "粘涤",
      // 					"level": 3,
      // 					"templateId": 341,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "纯涤",
      // 					"level": 3,
      // 					"templateId": 342,
      // 					"parentId": 118
      // 				},
      // 				{
      // 					"templateIdName": "粘麻",
      // 					"level": 3,
      // 					"templateId": 344,
      // 					"parentId": 118
      // 				}
      // 			]
      // 		},
      // 		{
      // 			"templateIdName": "混纺交织",
      // 			"level": 2,
      // 			"templateId": 130,
      // 			"parentId": 3,
      // 			"child": [{
      // 					"templateIdName": "纯纺",
      // 					"level": 3,
      // 					"templateId": 131,
      // 					"parentId": 130
      // 				},
      // 				{
      // 					"templateIdName": "混纺",
      // 					"level": 3,
      // 					"templateId": 132,
      // 					"parentId": 130
      // 				},
      // 				{
      // 					"templateIdName": "交织",
      // 					"level": 3,
      // 					"templateId": 133,
      // 					"parentId": 130
      // 				}
      // 			]
      // 		},
      // 		{
      // 			"templateIdName": "弹力",
      // 			"level": 2,
      // 			"templateId": 134,
      // 			"parentId": 3,
      // 			"child": [{
      // 					"templateIdName": "无弹",
      // 					"level": 3,
      // 					"templateId": 135,
      // 					"parentId": 134
      // 				},
      // 				{
      // 					"templateIdName": "经弹",
      // 					"level": 3,
      // 					"templateId": 136,
      // 					"parentId": 134
      // 				},
      // 				{
      // 					"templateIdName": "纬弹",
      // 					"level": 3,
      // 					"templateId": 137,
      // 					"parentId": 134
      // 				},
      // 				{
      // 					"templateIdName": "四面弹",
      // 					"level": 3,
      // 					"templateId": 138,
      // 					"parentId": 134
      // 				}
      // 			]
      // 		},
      // 		{
      // 			"templateIdName": "后整理",
      // 			"level": 2,
      // 			"templateId": 139,
      // 			"parentId": 3,
      // 			"child": [{
      // 					"templateIdName": "磨毛",
      // 					"level": 3,
      // 					"templateId": 140,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "植绒",
      // 					"level": 3,
      // 					"templateId": 141,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "抓毛",
      // 					"level": 3,
      // 					"templateId": 142,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "柔软",
      // 					"level": 3,
      // 					"templateId": 143,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "仿天丝",
      // 					"level": 3,
      // 					"templateId": 144,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "水洗",
      // 					"level": 3,
      // 					"templateId": 145,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "涂层",
      // 					"level": 3,
      // 					"templateId": 146,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "皮膜",
      // 					"level": 3,
      // 					"templateId": 147,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "烫金",
      // 					"level": 3,
      // 					"templateId": 148,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "烫银",
      // 					"level": 3,
      // 					"templateId": 149,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "复合",
      // 					"level": 3,
      // 					"templateId": 150,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "抓皱",
      // 					"level": 3,
      // 					"templateId": 151,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "丝光",
      // 					"level": 3,
      // 					"templateId": 152,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "剪花",
      // 					"level": 3,
      // 					"templateId": 153,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "烂花",
      // 					"level": 3,
      // 					"templateId": 154,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "压花",
      // 					"level": 3,
      // 					"templateId": 155,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "防水",
      // 					"level": 3,
      // 					"templateId": 156,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "阻燃",
      // 					"level": 3,
      // 					"templateId": 157,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "防静电",
      // 					"level": 3,
      // 					"templateId": 158,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "抗皱/免烫",
      // 					"level": 3,
      // 					"templateId": 159,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "全工艺",
      // 					"level": 3,
      // 					"templateId": 204,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "反做正",
      // 					"level": 3,
      // 					"templateId": 212,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "轻磨毛",
      // 					"level": 3,
      // 					"templateId": 213,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "重磨毛",
      // 					"level": 3,
      // 					"templateId": 214,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "碳素磨毛",
      // 					"level": 3,
      // 					"templateId": 215,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "拉绒",
      // 					"level": 3,
      // 					"templateId": 216,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "防酸",
      // 					"level": 3,
      // 					"templateId": 219,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "防紫外线",
      // 					"level": 3,
      // 					"templateId": 220,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "抗菌",
      // 					"level": 3,
      // 					"templateId": 221,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "刮色",
      // 					"level": 3,
      // 					"templateId": 224,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "仿丝绸",
      // 					"level": 3,
      // 					"templateId": 228,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "特氟隆",
      // 					"level": 3,
      // 					"templateId": 230,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "吸湿排汗",
      // 					"level": 3,
      // 					"templateId": 252,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "抓绒",
      // 					"level": 3,
      // 					"templateId": 258,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "拉毛",
      // 					"level": 3,
      // 					"templateId": 262,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "耐氯漂",
      // 					"level": 3,
      // 					"templateId": 310,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "覆膜",
      // 					"level": 3,
      // 					"templateId": 316,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "砂洗",
      // 					"level": 3,
      // 					"templateId": 318,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "涂蜡",
      // 					"level": 3,
      // 					"templateId": 319,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "凉感",
      // 					"level": 3,
      // 					"templateId": 329,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "防螨虫",
      // 					"level": 3,
      // 					"templateId": 330,
      // 					"parentId": 139
      // 				},
      // 				{
      // 					"templateIdName": "绣花",
      // 					"level": 3,
      // 					"templateId": 337,
      // 					"parentId": 139
      // 				}
      // 			]
      // 		},
      // 		{
      // 			"templateIdName": "品名",
      // 			"level": 2,
      // 			"templateId": 160,
      // 			"parentId": 3,
      // 			"child": [{
      // 					"templateIdName": "平纹",
      // 					"level": 3,
      // 					"templateId": 174,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "帆布",
      // 					"level": 3,
      // 					"templateId": 175,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "细布",
      // 					"level": 3,
      // 					"templateId": 176,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "府绸",
      // 					"level": 3,
      // 					"templateId": 177,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "多经多纬",
      // 					"level": 3,
      // 					"templateId": 178,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "双经双纬",
      // 					"level": 3,
      // 					"templateId": 179,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "双经单纬",
      // 					"level": 3,
      // 					"templateId": 180,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "单经双纬",
      // 					"level": 3,
      // 					"templateId": 181,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "2/1斜纹",
      // 					"level": 3,
      // 					"templateId": 182,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "3/1纱卡",
      // 					"level": 3,
      // 					"templateId": 183,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "线卡",
      // 					"level": 3,
      // 					"templateId": 184,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "半线卡",
      // 					"level": 3,
      // 					"templateId": 185,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "破卡",
      // 					"level": 3,
      // 					"templateId": 186,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "纱绢",
      // 					"level": 3,
      // 					"templateId": 187,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "线绢",
      // 					"level": 3,
      // 					"templateId": 188,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "直贡",
      // 					"level": 3,
      // 					"templateId": 189,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "横贡",
      // 					"level": 3,
      // 					"templateId": 190,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "防羽布",
      // 					"level": 3,
      // 					"templateId": 191,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "人字斜",
      // 					"level": 3,
      // 					"templateId": 192,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "骑兵斜",
      // 					"level": 3,
      // 					"templateId": 193,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "灯芯绒",
      // 					"level": 3,
      // 					"templateId": 194,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "灯芯条",
      // 					"level": 3,
      // 					"templateId": 195,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "提花条",
      // 					"level": 3,
      // 					"templateId": 196,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "方格",
      // 					"level": 3,
      // 					"templateId": 197,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "横条",
      // 					"level": 3,
      // 					"templateId": 198,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "米通",
      // 					"level": 3,
      // 					"templateId": 199,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "牛津纺",
      // 					"level": 3,
      // 					"templateId": 200,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "小提花",
      // 					"level": 3,
      // 					"templateId": 201,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "乱纹",
      // 					"level": 3,
      // 					"templateId": 202,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "双层",
      // 					"level": 3,
      // 					"templateId": 203,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "双面斜",
      // 					"level": 3,
      // 					"templateId": 205,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "大提花",
      // 					"level": 3,
      // 					"templateId": 206,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "竹节",
      // 					"level": 3,
      // 					"templateId": 207,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "皱布",
      // 					"level": 3,
      // 					"templateId": 208,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "空筘条",
      // 					"level": 3,
      // 					"templateId": 209,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "双经斜",
      // 					"level": 3,
      // 					"templateId": 211,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "毛圈布",
      // 					"level": 3,
      // 					"templateId": 217,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "纱罗",
      // 					"level": 3,
      // 					"templateId": 218,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "泡泡布",
      // 					"level": 3,
      // 					"templateId": 223,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "提花格",
      // 					"level": 3,
      // 					"templateId": 227,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "复合斜纹",
      // 					"level": 3,
      // 					"templateId": 229,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "巴厘纱",
      // 					"level": 3,
      // 					"templateId": 250,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "蜂巢布",
      // 					"level": 3,
      // 					"templateId": 259,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "纱布",
      // 					"level": 3,
      // 					"templateId": 311,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "螺纹布",
      // 					"level": 3,
      // 					"templateId": 320,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "鱼骨纹",
      // 					"level": 3,
      // 					"templateId": 325,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "平卡条",
      // 					"level": 3,
      // 					"templateId": 343,
      // 					"parentId": 160
      // 				},
      // 				{
      // 					"templateIdName": "汗布",
      // 					"level": 3,
      // 					"templateId": 347,
      // 					"parentId": 160
      // 				}
      // 			]
      // 		},
      // 		{
      // 			"templateIdName": "用途",
      // 			"level": 2,
      // 			"templateId": 225,
      // 			"parentId": 3,
      // 			"child": [{
      // 					"templateIdName": "舞蹈鞋",
      // 					"level": 3,
      // 					"templateId": 226,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "衬衫",
      // 					"level": 3,
      // 					"templateId": 231,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "口袋布",
      // 					"level": 3,
      // 					"templateId": 232,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "浴袍/浴衣",
      // 					"level": 3,
      // 					"templateId": 251,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "工装",
      // 					"level": 3,
      // 					"templateId": 260,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "口罩布",
      // 					"level": 3,
      // 					"templateId": 261,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "家居服",
      // 					"level": 3,
      // 					"templateId": 309,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "裤装",
      // 					"level": 3,
      // 					"templateId": 317,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "外套",
      // 					"level": 3,
      // 					"templateId": 331,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "夹克",
      // 					"level": 3,
      // 					"templateId": 332,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "箱包",
      // 					"level": 3,
      // 					"templateId": 333,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "里料",
      // 					"level": 3,
      // 					"templateId": 334,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "裙装",
      // 					"level": 3,
      // 					"templateId": 338,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "风衣",
      // 					"level": 3,
      // 					"templateId": 339,
      // 					"parentId": 225
      // 				},
      // 				{
      // 					"templateIdName": "童装",
      // 					"level": 3,
      // 					"templateId": 352,
      // 					"parentId": 225
      // 				}
      // 			]
      // 		}
      // 	],
      // 	[{
      // 		"templateIdName": "面料类型",
      // 		"level": 2,
      // 		"templateId": 113,
      // 		"parentId": 3,
      // 		"child": [{
      // 				"templateIdName": "半漂布",
      // 				"level": 3,
      // 				"templateId": 114,
      // 				"parentId": 113
      // 			},
      // 			{
      // 				"templateIdName": "染色布",
      // 				"level": 3,
      // 				"templateId": 115,
      // 				"parentId": 113
      // 			},
      // 			{
      // 				"templateIdName": "印花布",
      // 				"level": 3,
      // 				"templateId": 116,
      // 				"parentId": 113
      // 			},
      // 			{
      // 				"templateIdName": "色织布",
      // 				"level": 3,
      // 				"templateId": 117,
      // 				"parentId": 113
      // 			},
      // 			{
      // 				"templateIdName": "针织布",
      // 				"level": 3,
      // 				"templateId": 315,
      // 				"parentId": 113
      // 			}
      // 		]
      // 	}],
      // 	[{
      // 		"templateIdName": "原料",
      // 		"level": 2,
      // 		"templateId": 118,
      // 		"parentId": 3,
      // 		"child": [{
      // 				"templateIdName": "全棉",
      // 				"level": 3,
      // 				"templateId": 119,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "亚麻",
      // 				"level": 3,
      // 				"templateId": 120,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "涤棉",
      // 				"level": 3,
      // 				"templateId": 123,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "锦棉",
      // 				"level": 3,
      // 				"templateId": 124,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "腈棉",
      // 				"level": 3,
      // 				"templateId": 125,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "粘胶(人棉)",
      // 				"level": 3,
      // 				"templateId": 126,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "天丝",
      // 				"level": 3,
      // 				"templateId": 127,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "莫代尔",
      // 				"level": 3,
      // 				"templateId": 128,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "CVC",
      // 				"level": 3,
      // 				"templateId": 129,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "竹炭纤维",
      // 				"level": 3,
      // 				"templateId": 164,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "羊毛",
      // 				"level": 3,
      // 				"templateId": 326,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "粘棉",
      // 				"level": 3,
      // 				"templateId": 335,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "麻棉",
      // 				"level": 3,
      // 				"templateId": 336,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "粘涤",
      // 				"level": 3,
      // 				"templateId": 341,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "纯涤",
      // 				"level": 3,
      // 				"templateId": 342,
      // 				"parentId": 118
      // 			},
      // 			{
      // 				"templateIdName": "粘麻",
      // 				"level": 3,
      // 				"templateId": 344,
      // 				"parentId": 118
      // 			}
      // 		]
      // 	}],
      // 	[{
      // 		"templateIdName": "混纺交织",
      // 		"level": 2,
      // 		"templateId": 130,
      // 		"parentId": 3,
      // 		"child": [{
      // 				"templateIdName": "纯纺",
      // 				"level": 3,
      // 				"templateId": 131,
      // 				"parentId": 130
      // 			},
      // 			{
      // 				"templateIdName": "混纺",
      // 				"level": 3,
      // 				"templateId": 132,
      // 				"parentId": 130
      // 			},
      // 			{
      // 				"templateIdName": "交织",
      // 				"level": 3,
      // 				"templateId": 133,
      // 				"parentId": 130
      // 			}
      // 		]
      // 	}],
      // 	[{
      // 		"templateIdName": "弹力",
      // 		"level": 2,
      // 		"templateId": 134,
      // 		"parentId": 3,
      // 		"child": [{
      // 				"templateIdName": "无弹",
      // 				"level": 3,
      // 				"templateId": 135,
      // 				"parentId": 134
      // 			},
      // 			{
      // 				"templateIdName": "经弹",
      // 				"level": 3,
      // 				"templateId": 136,
      // 				"parentId": 134
      // 			},
      // 			{
      // 				"templateIdName": "纬弹",
      // 				"level": 3,
      // 				"templateId": 137,
      // 				"parentId": 134
      // 			},
      // 			{
      // 				"templateIdName": "四面弹",
      // 				"level": 3,
      // 				"templateId": 138,
      // 				"parentId": 134
      // 			}
      // 		]
      // 	}],
      // 	[{
      // 		"templateIdName": "后整理",
      // 		"level": 2,
      // 		"templateId": 139,
      // 		"parentId": 3,
      // 		"child": [{
      // 				"templateIdName": "磨毛",
      // 				"level": 3,
      // 				"templateId": 140,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "植绒",
      // 				"level": 3,
      // 				"templateId": 141,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "抓毛",
      // 				"level": 3,
      // 				"templateId": 142,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "柔软",
      // 				"level": 3,
      // 				"templateId": 143,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "仿天丝",
      // 				"level": 3,
      // 				"templateId": 144,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "水洗",
      // 				"level": 3,
      // 				"templateId": 145,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "涂层",
      // 				"level": 3,
      // 				"templateId": 146,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "皮膜",
      // 				"level": 3,
      // 				"templateId": 147,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "烫金",
      // 				"level": 3,
      // 				"templateId": 148,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "烫银",
      // 				"level": 3,
      // 				"templateId": 149,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "复合",
      // 				"level": 3,
      // 				"templateId": 150,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "抓皱",
      // 				"level": 3,
      // 				"templateId": 151,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "丝光",
      // 				"level": 3,
      // 				"templateId": 152,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "剪花",
      // 				"level": 3,
      // 				"templateId": 153,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "烂花",
      // 				"level": 3,
      // 				"templateId": 154,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "压花",
      // 				"level": 3,
      // 				"templateId": 155,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "防水",
      // 				"level": 3,
      // 				"templateId": 156,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "阻燃",
      // 				"level": 3,
      // 				"templateId": 157,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "防静电",
      // 				"level": 3,
      // 				"templateId": 158,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "抗皱/免烫",
      // 				"level": 3,
      // 				"templateId": 159,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "全工艺",
      // 				"level": 3,
      // 				"templateId": 204,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "反做正",
      // 				"level": 3,
      // 				"templateId": 212,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "轻磨毛",
      // 				"level": 3,
      // 				"templateId": 213,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "重磨毛",
      // 				"level": 3,
      // 				"templateId": 214,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "碳素磨毛",
      // 				"level": 3,
      // 				"templateId": 215,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "拉绒",
      // 				"level": 3,
      // 				"templateId": 216,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "防酸",
      // 				"level": 3,
      // 				"templateId": 219,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "防紫外线",
      // 				"level": 3,
      // 				"templateId": 220,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "抗菌",
      // 				"level": 3,
      // 				"templateId": 221,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "刮色",
      // 				"level": 3,
      // 				"templateId": 224,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "仿丝绸",
      // 				"level": 3,
      // 				"templateId": 228,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "特氟隆",
      // 				"level": 3,
      // 				"templateId": 230,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "吸湿排汗",
      // 				"level": 3,
      // 				"templateId": 252,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "抓绒",
      // 				"level": 3,
      // 				"templateId": 258,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "拉毛",
      // 				"level": 3,
      // 				"templateId": 262,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "耐氯漂",
      // 				"level": 3,
      // 				"templateId": 310,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "覆膜",
      // 				"level": 3,
      // 				"templateId": 316,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "砂洗",
      // 				"level": 3,
      // 				"templateId": 318,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "涂蜡",
      // 				"level": 3,
      // 				"templateId": 319,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "凉感",
      // 				"level": 3,
      // 				"templateId": 329,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "防螨虫",
      // 				"level": 3,
      // 				"templateId": 330,
      // 				"parentId": 139
      // 			},
      // 			{
      // 				"templateIdName": "绣花",
      // 				"level": 3,
      // 				"templateId": 337,
      // 				"parentId": 139
      // 			}
      // 		]
      // 	}],
      // 	[{
      // 		"templateIdName": "品名",
      // 		"level": 2,
      // 		"templateId": 160,
      // 		"parentId": 3,
      // 		"child": [{
      // 				"templateIdName": "平纹",
      // 				"level": 3,
      // 				"templateId": 174,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "帆布",
      // 				"level": 3,
      // 				"templateId": 175,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "细布",
      // 				"level": 3,
      // 				"templateId": 176,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "府绸",
      // 				"level": 3,
      // 				"templateId": 177,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "多经多纬",
      // 				"level": 3,
      // 				"templateId": 178,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "双经双纬",
      // 				"level": 3,
      // 				"templateId": 179,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "双经单纬",
      // 				"level": 3,
      // 				"templateId": 180,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "单经双纬",
      // 				"level": 3,
      // 				"templateId": 181,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "2/1斜纹",
      // 				"level": 3,
      // 				"templateId": 182,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "3/1纱卡",
      // 				"level": 3,
      // 				"templateId": 183,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "线卡",
      // 				"level": 3,
      // 				"templateId": 184,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "半线卡",
      // 				"level": 3,
      // 				"templateId": 185,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "破卡",
      // 				"level": 3,
      // 				"templateId": 186,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "纱绢",
      // 				"level": 3,
      // 				"templateId": 187,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "线绢",
      // 				"level": 3,
      // 				"templateId": 188,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "直贡",
      // 				"level": 3,
      // 				"templateId": 189,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "横贡",
      // 				"level": 3,
      // 				"templateId": 190,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "防羽布",
      // 				"level": 3,
      // 				"templateId": 191,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "人字斜",
      // 				"level": 3,
      // 				"templateId": 192,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "骑兵斜",
      // 				"level": 3,
      // 				"templateId": 193,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "灯芯绒",
      // 				"level": 3,
      // 				"templateId": 194,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "灯芯条",
      // 				"level": 3,
      // 				"templateId": 195,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "提花条",
      // 				"level": 3,
      // 				"templateId": 196,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "方格",
      // 				"level": 3,
      // 				"templateId": 197,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "横条",
      // 				"level": 3,
      // 				"templateId": 198,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "米通",
      // 				"level": 3,
      // 				"templateId": 199,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "牛津纺",
      // 				"level": 3,
      // 				"templateId": 200,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "小提花",
      // 				"level": 3,
      // 				"templateId": 201,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "乱纹",
      // 				"level": 3,
      // 				"templateId": 202,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "双层",
      // 				"level": 3,
      // 				"templateId": 203,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "双面斜",
      // 				"level": 3,
      // 				"templateId": 205,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "大提花",
      // 				"level": 3,
      // 				"templateId": 206,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "竹节",
      // 				"level": 3,
      // 				"templateId": 207,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "皱布",
      // 				"level": 3,
      // 				"templateId": 208,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "空筘条",
      // 				"level": 3,
      // 				"templateId": 209,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "双经斜",
      // 				"level": 3,
      // 				"templateId": 211,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "毛圈布",
      // 				"level": 3,
      // 				"templateId": 217,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "纱罗",
      // 				"level": 3,
      // 				"templateId": 218,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "泡泡布",
      // 				"level": 3,
      // 				"templateId": 223,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "提花格",
      // 				"level": 3,
      // 				"templateId": 227,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "复合斜纹",
      // 				"level": 3,
      // 				"templateId": 229,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "巴厘纱",
      // 				"level": 3,
      // 				"templateId": 250,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "蜂巢布",
      // 				"level": 3,
      // 				"templateId": 259,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "纱布",
      // 				"level": 3,
      // 				"templateId": 311,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "螺纹布",
      // 				"level": 3,
      // 				"templateId": 320,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "鱼骨纹",
      // 				"level": 3,
      // 				"templateId": 325,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "平卡条",
      // 				"level": 3,
      // 				"templateId": 343,
      // 				"parentId": 160
      // 			},
      // 			{
      // 				"templateIdName": "汗布",
      // 				"level": 3,
      // 				"templateId": 347,
      // 				"parentId": 160
      // 			}
      // 		]
      // 	}],
      // 	[{
      // 		"templateIdName": "用途",
      // 		"level": 2,
      // 		"templateId": 225,
      // 		"parentId": 3,
      // 		"child": [{
      // 				"templateIdName": "舞蹈鞋",
      // 				"level": 3,
      // 				"templateId": 226,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "衬衫",
      // 				"level": 3,
      // 				"templateId": 231,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "口袋布",
      // 				"level": 3,
      // 				"templateId": 232,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "浴袍/浴衣",
      // 				"level": 3,
      // 				"templateId": 251,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "工装",
      // 				"level": 3,
      // 				"templateId": 260,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "口罩布",
      // 				"level": 3,
      // 				"templateId": 261,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "家居服",
      // 				"level": 3,
      // 				"templateId": 309,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "裤装",
      // 				"level": 3,
      // 				"templateId": 317,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "外套",
      // 				"level": 3,
      // 				"templateId": 331,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "夹克",
      // 				"level": 3,
      // 				"templateId": 332,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "箱包",
      // 				"level": 3,
      // 				"templateId": 333,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "里料",
      // 				"level": 3,
      // 				"templateId": 334,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "裙装",
      // 				"level": 3,
      // 				"templateId": 338,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "风衣",
      // 				"level": 3,
      // 				"templateId": 339,
      // 				"parentId": 225
      // 			},
      // 			{
      // 				"templateIdName": "童装",
      // 				"level": 3,
      // 				"templateId": 352,
      // 				"parentId": 225
      // 			}
      // 		]
      // 	}],

      // ],
      indexArr: "",
    };
  },
  computed: {
    fileURL() {
      return config.fileURL;
    },
    ...mapGetters({
      screen: GET_SCREEN,
    }),
  },
  watch: {
    "$route.path": function (val, old) {
      if (old === "/goodsDetail" && this.list.length === 0) {
        this.fetchFun();
      }
    },
    selectList: {
      handler: function (val) {
        this.selectedFilter = val;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getStock: CommonUtils.getStock,
    formatDate: CommonUtils.format,
    ...mapMutations([SET_NAV_CALLBACK]),
    //客服
    toKeFu() {
      //   window._MEIQIA("showPanel");
      //   this.SET_BACK_BUTTON_EVENT(() => {
      //     window._MEIQIA("hidePanel");
      //     this.SET_BACK_BUTTON_EVENT(() => {
      //       this.$router.go(-1);
      //     });
      //   });
      this.$router.push({
        path: "/styleDetail",
        query: {
          src: "https://www.echatsoft.com/visitor/mobile/chat.html?companyId=530696",
        },
      });
    },
    //接收菜单结果
    confirm(e) {
      //   console.log('接手菜单====', e);
      let menu = e.menu;
      let res = JSON.parse(JSON.stringify(e.index[0]));
      var arr = [];
      var arrName = [];
      res.forEach((item, i) => {
        // console.log('遍历菜单====', item);
        let isSelect = false; // 当前菜单是否有选中的菜单项
        let selectCard = [];
        for (let m = 0; m < item.child.length; m++) {
          if (item.child[m].selected == true) {
            isSelect = true;
            selectCard.push(item.child[m].templateIdName);

            // console.log('selectCardselectCard================',selectCard)
            arr.push(item.child[m].templateId);
            arrName.push(item.child[m].templateIdName);
          }
        }
        if (isSelect) {
          // 当前菜单有选中的菜单项
          for (let i = 0; i < menu.length; i++) {
            if (menu[i].id == item.templateId) {
              menu[i].isSelect = true;
              menu[i].name = selectCard.join(",");
            }
          }
        } else {
          for (let i = 0; i < menu.length; i++) {
            if (menu[i].id == item.templateId) {
              menu[i].name = item.templateIdName;
              menu[i].isSelect = false;
            }
          }
        }
        // console.log('item================',item)
      });
      this.$forceUpdate();
      //   console.log('遍历id====', arr);
      //   console.log('遍历name====', arrName);
      this.pageConfig.goodsSearchTemplateIdList = [];
      arr.forEach((item) => {
        this.pageConfig.goodsSearchTemplateIdList.push(item);
      });
      this.flushList();
    },
    // 获取筛选参数
    selectGoodsSearchTemplate(id) {
      let vm = this;
      var array = [];
      api.selectAllLevelGoodsSearchTemplateByGoodsId(id).then((result) => {
        array.push(result.data);
        for (var i = 0; i < result.data.length; i++) {
          // console.log('item======',result.data[i]);
          var arr = [result.data[i]];
          array.push(arr);
        }
        // console.log('筛选======',array);
        vm.fabricList = array;
      });
    },
    flushList() {
      this.$refs.list.flushList();
    },
    fetchData() {
      this.$refs.list.fetchData();
    },
    // 排序变更重新请求列表
    sortChange(params) {
      if (params) {
        this.$set(this.pageConfig.sort, 0, params);
        this.flushList();
      }
    },
    // 点击排序默认按钮时触发
    sortReset() {
      this.pageConfig.sort = [];
      this.flushList();
    },
    // 过滤显示商品属性
    filterisAppMain(list, order) {
      function filterIsMain(item) {
        return item.isAppMain === order && item.detailsValue;
      }
      return list.filter(filterIsMain);
    },
    // 过滤显示商品属性
    filterDetailsName(list, detailsName) {
      var result = list.filter((item) => item.detailsName === detailsName);
      if (result.length > 0) {
        if (
          result[0].detailsValue !== null &&
          result[0].detailsValue !== undefined
        ) {
          return result[0].detailsValue;
        }
        return "";
      }
      return "";
    },
    // 点击右上角筛选按钮
    filterFun() {
      this.showfilter = true;
    },

    func() {},
    // 确认提交并关闭筛选内容
    submitFilter() {
      this.pageConfig.goodsSearchTemplateIdList = [];
      //   console.log(this.selectList,"this.selectListthis.selectListthis.selectList")
      this.selectList.forEach((item) => {
        this.pageConfig.goodsSearchTemplateIdList.push(item.templateId);
      });
      this.flushList();
      this.showfilter = false;
    },
    // 查看商品详情
    view(id) {
      // this.$ref.list.scrollTop
      let scrollTop = window.document.getElementById("list").scrollTop;
      // console.log('scrollTop: ', window.document.getElementById('list').scrollTop)
      // console.log('this.$refs.list.scrollTop: ', this.$refs.list.scrollTop)
      this.$router.push({
        path: "goodsDetail",
        query: {
          goodsId: id,
          scrollTop: scrollTop,
        },
      });
    },
    backFun() {
      if (this.isFromCategory) {
        this.$router.push({
          path: "/category",
        });
      } else {
        this.$router.push({
          path: "/home",
        });
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm.$nextTick(() => {
      //   if (vm.$refs.list) {
      //     console.log('vm.$refs.list: ', vm.$refs.list)
      //     window.document.getElementById('list').scrollTop = 180
      //   }
      // })
      vm.isFromCategory = false;
      if (from && from.path === "/category") {
        vm.isFromCategory = true;
      }
      if (vm.SET_NAV_CALLBACK) {
        if (vm.backFun) {
          vm.SET_NAV_CALLBACK({
            backFun: vm.backFun,
          });
        }
        if (vm.filterFun) {
          vm.SET_NAV_CALLBACK({
            filterFun: vm.filterFun,
          });
        }
      }
      if (from.path === "/goodsDetail") {
        vm.$nextTick(() => {
          // console.log('from: ', from)
          // console.log('vm.$refs.list: ', vm.$refs.list)
          if (vm.showList) {
            // console.log('scrollTop: ', window.document.getElementById('list').scrollTop)
            // window.document.getElementById('list').scrollTop = 180
            window.document.getElementById("list").scrollTop =
              from.query.scrollTop;
          }
        });
      }
      if (from.path !== "/goodsDetail") {
        vm.pageConfig = {
          page: 0,
          size: 10,
          goodsTemplateId: "",
          goodsSearchTemplateIdList: [],
          sort: [],
          keyword: null,
          explosion: null,
          recommend: null,
        };
        if (vm.$route.query || vm.$route.params) {
          vm.showList = false;
          let param =
            vm.$route.params != null && Object.keys(vm.$route.params).length > 0
              ? vm.$route.params
              : vm.$route.query;
          // 是否为爆款列表
          if (param.explosion) {
            vm.pageConfig.explosion = param.explosion;
          }
          // 是否为推荐列表
          if (param.recommend) {
            vm.pageConfig.recommend = param.recommend;
          }
          // 商品大类绑定
          if (param.templateId) {
            vm.pageConfig.goodsTemplateId = param.templateId;
            // 获取商品大类相关信息（包括站位图等）
            // let postData = {
            //   templateId: param.templateId
            // }
            // api.selectGoodsTemplateInfo(postData).then(res => {
            //   vm.templateInfo = res.data
            // })
          }
          // 关键字绑定
          if (param.keyword) {
            vm.pageConfig.keyword = param.keyword;

            vm.pageConfig.goodsSearchTemplateIdList = [];
          }
          // 商品属性绑定
          if (param.selectList) {
            vm.selectList = param.selectList;
            vm.selectList.forEach((item) => {
              vm.pageConfig.goodsSearchTemplateIdList.push(item.templateId);
            });
          }
          // 搜索清除重新遍历面料筛选条件
          // console.log( vm.pageConfig," vm.pageConfig vm.pageConfig vm.pageConfig")
          if (
            vm.pageConfig.goodsTemplateId &&
            vm.pageConfig.goodsTemplateId != null
          ) {
            vm.selectGoodsSearchTemplate(vm.pageConfig.goodsTemplateId);
          }
          vm.$nextTick(() => {
            vm.showList = true;
            if (vm.$route.query.templateId) {
              vm.selectGoodsSearchTemplate(vm.$route.query.templateId);
            }
          });
        }
      }
    });
  },
  mounted() {
    // this.SET_NAV_CALLBACK({
    //   backFun: this.backFun,
    //   filterFun: this.filterFun
    // })
    if (this.$route.query.templateId) {
      this.selectGoodsSearchTemplate(this.$route.query.templateId);
    }
    // console.log(this.$route.query.templateId,"类型i")
  },
  created() {},
  components: {
    YYFilter: () => import("./filterDropdown/filterlist.vue"),
  },
};
</script>
<style  lang="scss"  scoped>
/deep/ .DeviceInfo {
  #main .app-content {
    overflow: hidden;
  }
}
.page-goods-list {
  height: 100%;
  overflow-y: hidden;
}
.list-bg {
  margin-top: 5px;
  background-color: #eee;
}
.border-bottom {
  border-bottom: 1px solid #ddd;
  border-width: thin;
}
.subordinate-detial {
  display: inline-block;
}
.mainDetail {
  line-height: 24px;
  font-weight: 500;
  font-size: 15px;
  margin-right: 12px;
}
.subordinate-detial::after {
  content: "|";
  margin: 0 8px;
}
.subordinate-detial-prx::after {
  color: #959595;
}
.subordinate-detial:last-of-type::after {
  display: none;
}
/* .goods-box >>> .mainDetail + .mainDetail{
    margin-left: 16px;
  } */
/* .goods-box >>> .subordinate-detial +.subordinate-detial {
    border-left: 1px solid #ccc;
    margin-left: 10px;
    padding-left: 10px;
  } */
.goods-box {
  margin-top: 6px;
  padding: 10px 10px;
  background-color: #ffffff;
}
.goods-box p {
  margin: 6px 0;
}
.van-tag {
  font-size: 12px;
  display: inline-block;
  text-align: center;
  /* margin-right: 0.5vw; */
  margin-right: 5px;
  padding: 0 5px;
  /* padding: 0.2vh 0.2vw; */
  /* width: 6.7vw;
    height: 1.9vh; */
  /* width: 34px; */
  height: 18px;
  line-height: 18px;
}
.top-offset {
  position: relative;
  top: -10px;
}
.finished-text {
  line-height: 26px;
  margin-top: 25px;
}
</style>
